module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAABaCAMAAABubpNyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABtQTFRF/9pA//O///bP/+Rw/+2f/+Bg/+Z//84A////uCtRywAAAAl0Uk5T//////////8AU094EgAAAKhJREFUeNrs2l0LgCAMheGtD+v//+LoLqTS2hpi77mOnmB6QEnW0AicI7eEBs6bi1kmcHBwZ5ymqkyHd1Q8rldcqqyG7JMLSf/l5H4Qc8ZZZ5ful5dmnGVlwsF1wwXvO2urwNGZcHB0Jp1JZ8LBwX3BPTwsc/PQCPciltlx4wcHt2fQcga/fScPO8XYKn1zo5Qz0plwcB6choS/Ary54KyhgYNrk9sEGAD6MBzcvMf5ggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/newspaper@2x.png
// module id = 1273
// module chunks = 0